import TeamUpdateCard from '../components/TeamUpdateCard.jsx'
import { TEAMS } from '../data/teams.js'
import { PILLARS } from '../data/pillars.js'

/**
 * TeamUpdatesPillar — each team's weekly TLDR / Wins / Flags in one
 * place, feeding the executive summary.
 *
 * Goal-level weekly summaries cover the work against specific goals.
 * This pillar covers team-level narrative — what the team as a whole
 * is doing / blocked on — which often captures cross-goal themes that
 * no single goal TLDR would.
 */
export default function TeamUpdatesPillar() {
  const meta = PILLARS.find((p) => p.id === 'team-updates')
  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            marginBottom: 4,
          }}
        >
          <span style={{ fontSize: 20 }}>{meta?.icon || '📣'}</span>
          <h2 style={{ fontSize: 16, fontWeight: 800, color: meta?.color || 'var(--text)' }}>
            {meta?.name || 'Team Updates'}
          </h2>
        </div>
        <p
          style={{
            fontSize: 12,
            color: 'var(--muted)',
            margin: 0,
            lineHeight: 1.5,
            fontStyle: 'italic',
          }}
        >
          One update per team, per week. DRIs post a TLDR, call out wins,
          and flag blockers. These feed the executive summary alongside
          goal-level updates — so post anything the whole company should
          know about your team's work this week.
        </p>
      </div>

      {TEAMS.map((team) => (
        <TeamUpdateCard key={team.id} team={team} />
      ))}
    </div>
  )
}
